import { Navigation, Footer } from "@/components/Layout";
import { SEO } from "@/components/SEO";

export default function Terms() {
  return (
    <div className="min-h-screen bg-white" data-testid="terms-page">
      <SEO 
        title="Terms of Service"
        description="Steward Lots terms of service. Transparent terms for our Christ-led land stewardship business. No hidden clauses, no dark patterns."
        path="/terms"
      />
      <Navigation mode="builder" />

      <div className="pt-24 pb-16 px-6 md:px-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-serif text-3xl md:text-4xl text-[#1C1917] mb-8">
            Terms of Service
          </h1>
          
          <div className="prose prose-lg max-w-none text-[#57534E]">
            <p className="text-sm text-[#A8A29E] mb-8">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Agreement to Terms</h2>
              <p>
                By accessing or using the Steward Lots™ website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Our Services</h2>
              <p>
                Steward Lots™ provides land stewardship and facilitation services, connecting land sellers with potential buyers. We operate as a facilitator and do not act as a licensed real estate broker in all jurisdictions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Not Legal or Tax Advice</h2>
              <p className="bg-[#F5F5F4] p-4 border border-[#E7E5E4]">
                <strong>Important:</strong> Nothing on this website or in our communications constitutes legal, tax, or financial advice. We strongly recommend consulting with qualified professionals before making any real estate decisions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Compensation Disclosure</h2>
              <p>
                We commit to full transparency in our compensation. On every transaction we facilitate, our compensation will be disclosed to all parties in writing before closing. We do not use hidden spreads or undisclosed markups.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">User Representations</h2>
              <p>By using our services, you represent that:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>You are at least 18 years of age</li>
                <li>Information you provide is accurate and complete</li>
                <li>You have the legal authority to enter into transactions related to properties you submit</li>
                <li>You will use our services in good faith</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law, Steward Lots™ shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Indemnification</h2>
              <p>
                You agree to indemnify and hold harmless Steward Lots™ and its officers, employees, and agents from any claims, damages, or expenses arising from your use of our services or violation of these terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Changes to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. Continued use of our services after changes constitutes acceptance of the modified terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Governing Law</h2>
              <p>
                These terms shall be governed by and construed in accordance with the laws of the state in which Steward Lots™ operates, without regard to conflict of law principles.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Contact</h2>
              <p>
                Questions about these Terms of Service may be directed to:
              </p>
              <p className="mt-2">
                <strong>Email:</strong>{" "}
                <a href="mailto:mark@stewardlots.org" className="text-[#BFA15F] hover:underline">
                  mark@stewardlots.org
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
